// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bpauM","questions":"styles_questions__1ziGt","footer":"styles_footer__2_I0u"};